import { AssignmentsList } from '../components';
import useFilteredAssignments from 'pages/Assignments/useFilteredAssignments';
import { AssignmentExtendedModel, CaseTypeEnum } from 'api/model';
import { Outlet, useNavigate } from 'react-router-dom';
import Routes from 'constants/Routes';
import { useMemo } from 'react';
import Roles from 'constants/Roles';
import useMe from 'contexts/authentication/useMe';
import BulkMessages from 'pages/GlobalSearch/BulkMessages';
import BulkOperations from 'pages/GlobalSearch/BulkOperations';
import useAssignmentsBulkOperations from 'pages/GlobalSearch/useAssignmentsBulkOperations';
import InternalDeliveryAssignmentsFilterBar from './components/InternalDeliveryAssignmentsFilterBar';
import { TableIdentifierEnum } from 'contexts/basicData/useActiveColumns';
import { useCompanyGetStrangnasLogisticsCompanies } from 'api/company/company';

const AdvertisingAssignments = () => {
  const navigate = useNavigate();
  const { filteredAssignments, update } = useFilteredAssignments(
    CaseTypeEnum.InternalDelivery
  );
  const me = useMe();
  const userIsGoSupport = me?.roles.includes(Roles.GoSupport);

  const { data: strangnasLogistic } =
    useCompanyGetStrangnasLogisticsCompanies();

  const onlyStrangnasAssignments = useMemo(() => {
    const normalizeZip = (zip: string | undefined) =>
      (zip ?? '').replace(/\s/g, '');
    const expectedZip = normalizeZip(strangnasLogistic?.zip);
    return filteredAssignments.filter(
      (a) => normalizeZip(a.assignment.fromZip) === expectedZip
    );
  }, [filteredAssignments, strangnasLogistic?.zip]);

  const assignmentsBulkOperations = useAssignmentsBulkOperations(
    onlyStrangnasAssignments ?? [],
    () => update(false)
  );

  const handleAssignmentItemClick = (model: any) => {
    const avm = model as AssignmentExtendedModel;
    navigate(
      `${Routes.internalDeliveryGroup.assignments.index}/${avm.case.caseID}?assignment=${
        avm.assignment.assignmentID
      }`
    );
  };

  const bulkMessagesButton = userIsGoSupport ? (
    <BulkMessages bulkOperations={assignmentsBulkOperations} />
  ) : null;

  return (
    <>
      <InternalDeliveryAssignmentsFilterBar
        assignments={onlyStrangnasAssignments}
        showSendToFieldTesters={false}
        onUpdate={() => update(false)}
      />
      {!!onlyStrangnasAssignments.length && userIsGoSupport && (
        <BulkOperations
          bulkActions={[bulkMessagesButton]}
          bulkOperations={assignmentsBulkOperations}
          handleAssignmentItemClick={(model: AssignmentExtendedModel) =>
            handleAssignmentItemClick(model)
          }
        />
      )}
      <AssignmentsList
        loading={false}
        tableIdentifier={
          TableIdentifierEnum.InternalDeliveryGroupAssignmentsTable
        }
        assignments={onlyStrangnasAssignments}
        bulkOperations={assignmentsBulkOperations}
        onAssignmentItemClick={handleAssignmentItemClick}
        onAssignmentUpdated={async () => {
          update(false);
        }}
        hideEstimatedDurationAndStartTime
        showStatusColors={false}
      />
      <Outlet />
    </>
  );
};

export default AdvertisingAssignments;
